<section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="row mt-5 mb-5">
                <div class="table-responsive table-style">
                    <table class="table table-head-fixed table-striped">
                        <thead class="text-center">
                        <tr>
                            <th>S.No</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Phone Number</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>View</th>
                        </tr>
                        </thead>
                        <tbody class="text-center" *ngIf="this.shopOwnerDetails.length > 0; else noDataFound">
                        <tr *ngFor="let user of this.shopOwnerDetails | filter: searchText; let i = index;">
                            <td>{{ i + 1 }}</td>
                            <td>{{ user.firstName || '-' }}</td>
                            <td>{{ user.lastName || '-' }}</td>
                            <td>{{ user.phoneNumber || '-' }}</td>
                            <td>{{ user.emailId || '-' }}</td>
                            <td>
                                <span class="badge" [ngClass]="{
                                'badge-gradient-green': user.approvalStatus === 'APPROVED',
                                'badge-gradient-red': user.approvalStatus !== 'APPROVED'}">
                                    {{ getApprovalStatusText(user.approvalStatus) }}</span>
                            </td>
                            <td>
                                <i class="bi bi-eye-fill" type="button" (click)="viewProfile(user.userId)"></i>
                            </td>
                        </tbody>
                        <ng-template #noDataFound>
                            <tr>
                                <td colspan="12" class="text-center text-danger">Data Not Found</td>
                            </tr>
                        </ng-template>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>